import { render } from "./edit-name.vue?vue&type=template&id=6acb374f&scoped=true"
import script from "./edit-name.vue?vue&type=script&lang=js"
export * from "./edit-name.vue?vue&type=script&lang=js"

import "./edit-name.vue?vue&type=style&index=0&id=6acb374f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acb374f"]])

export default __exports__